export default __webpack_public_path__ + "26568ff2bb987698a77776c33e80cd36.svg";